import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0 auto;
  max-width: 1200px;
`



// WEBPACK FOOTER //
// ./src/components/Dashboard/Wrapper.js